<div
  class="book-trade"
  *ngIf="legForms.length && (hasLastHandleVolBasedHedgeExecution || !volBased)"
>
  <div class="book-trade__actions">
    <div class="book-trade__actions__buttons">
      <div></div>
      <div>
        <button
          class="ui-button ui-button--success"
          (click)="bookTrade()"
          [disabled]="
            state() === 'BOOKING' ||
            state() === 'BOOKED' ||
            !acceptedQuoteForm.valid ||
            acceptedQuoteForm.dirty ||
            !rfqTradeCaptureParamsForm.valid
          "
        >
          Book trade
        </button>
      </div>
    </div>
    <div class="book-trade__actions__booked" *ngIf="state() === 'BOOKED'">
      <div></div>
      <div class="pointer" (click)="closeWindow()">
        Trade booked. Click to close window.
      </div>
      <div></div>
    </div>
  </div>
  <form [formGroup]="acceptedQuoteForm" [inert]="state() === 'BOOKED'">
    <div
      formArrayName="legs"
      class="book-trade__form book-trade__form__{{ premiumStyle }}"
      [ngClass]="{
        'book-trade__form__retrocession': useRetrocessionFee,
        'book-trade__form__generic-multi-hedge-mode': isGenericMultiHedge
      }"
    >
      <div></div>
      <div></div>
      <div></div>
      <div>Trade prem.</div>
      <div>Margin</div>
      <div *ngIf="useRetrocessionFee">Retro. fee</div>
      <div>Client prem.</div>
      <ng-container *ngIf="premiumStyle !== 'Amount'">
        <div></div>
        <div>Cash prem.</div>
      </ng-container>
      <div></div>
      <!-- END HEADER -->
      <ng-container *ngFor="let legForm of legForms.controls; let i = index">
        <ng-container [formGroup]="legForm">
          <div></div>
          <div>Leg {{ i + 1 }} Client {{ legForm.value.clientAction }}s</div>
          <div>
            {{
              rfqTradeCaptureParamsForm.value.tradeBookingPremiumCurrency ||
                legForm.value.premiumCurrency
            }}
          </div>
          <input-with-spinner
            formControlName="premiumValue"
            [inputValidator]="['numericShorthand']"
            [required]="true"
            [useBasicTextBox]="true"
            [readOnly]="true"
            [tabIndex]="-1"
          ></input-with-spinner>
          <input-with-spinner
            class="margin {{ marginClass[i] }}"
            formControlName="margin"
            [inputValidator]="['negativeNumericShorthand']"
            [required]="true"
            [useBasicTextBox]="true"
            (keyup)="onMarginKeyPress($event, i)"
            (onBlur)="onMarginBlur(i)"
          ></input-with-spinner>
          <input-with-spinner
            formControlName="retrocessionFee"
            [inputValidator]="['numericShorthand']"
            [required]="true"
            [useBasicTextBox]="true"
            (keyup)="onRetrocessionFeeKeyPress($event, i)"
            (onBlur)="onRetrocessionFeeBlur(i)"
            *ngIf="useRetrocessionFee"
          ></input-with-spinner>

          <input-with-spinner
            class="{{ clientPremiumClass[i] }}"
            formControlName="clientPremium"
            [inputValidator]="['numericShorthand']"
            [required]="true"
            [useBasicTextBox]="true"
            (keyup)="onPremiumKeyPress($event, i)"
            (onBlur)="onPremiumBlur(i)"
          ></input-with-spinner>
          <ng-container *ngIf="premiumStyle !== 'Amount'">
            <div [ngSwitch]="premiumStyle">
              <ng-container *ngSwitchCase="'Amount'"></ng-container>
              <ng-container *ngSwitchCase="'percent'">%</ng-container>
              <ng-container *ngSwitchDefault>{{ premiumStyle }}</ng-container>
            </div>
            <input-with-spinner
              formControlName="cashPremium"
              [inputValidator]="['numericShorthand']"
              [useBasicTextBox]="true"
              [readOnly]="true"
              [tabIndex]="-1"
            ></input-with-spinner>
          </ng-container>
          <div></div>
        </ng-container>
      </ng-container>
      @if (hedgeEditingEnable) {
        @if (isGenericMultiHedge) {
          <ng-container
            *ngTemplateOutlet="enableGenericMultiHedgeEditingTmpl"
          />
        } @else {
          <ng-container *ngTemplateOutlet="enableHedgeEditingTmpl" />
        }
      }
      <ng-container *ngIf="allPremiumDatesSame">
        <ng-container *ngIf="premiumStyle === 'Amount'">
          <div></div>
          <div></div>
          <div>Total prem.</div>
          <div>Client {{ totalClientPremiumDir }}</div>
          <div *ngIf="useRetrocessionFee"></div>
          <div>{{ premiumCurrency }}</div>
          <div>{{ totalClientPremium }}</div>
          <div></div>
        </ng-container>
        <ng-container *ngIf="premiumStyle !== 'Amount'">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div>Total prem.</div>
          <div>Client {{ totalCashPremiumDir }}</div>
          <div *ngIf="useRetrocessionFee"></div>
          <div>{{ premiumCurrency }}</div>
          <div>{{ totalCashPremium }}</div>
          <div></div>
        </ng-container>
      </ng-container>
    </div>
    <div
      class="book-trade__franchise book-trade__franchise_match"
      *ngIf="
        volBased &&
        franchiseCredit.franchiseCreditCurrency ===
          lastNewVolBasedQuoteResponse.premiumCurrency
      "
    >
      <div></div>
      <div>Franchise Value</div>
      <div>{{ franchiseCredit.franchiseCreditCurrency }}</div>
      <input-with-spinner
        formControlName="franchiseCreditInFranchiseCreditCurrency"
        [inputValidator]="['numericShorthand']"
        [required]="true"
        [useBasicTextBox]="true"
        [tabIndex]="-1"
        (onBlur)="onCreditBlur('franchiseCreditInFranchiseCreditCurrency')"
      ></input-with-spinner>
      <div></div>
    </div>
    <div
      class="book-trade__franchise book-trade__franchise_nomatch"
      *ngIf="
        volBased &&
        franchiseCredit.franchiseCreditCurrency !==
          lastNewVolBasedQuoteResponse.premiumCurrency
      "
    >
      <div></div>
      <div>Franchise Value</div>
      <div>{{ lastNewVolBasedQuoteResponse.premiumCurrency }}</div>
      <input-with-spinner
        formControlName="franchiseCreditInPremiumCurrency"
        [inputValidator]="['numericShorthand']"
        [required]="true"
        [useBasicTextBox]="true"
        (onBlur)="onCreditBlur('franchiseCreditInPremiumCurrency')"
      ></input-with-spinner>
      <div>{{ franchiseCredit.franchiseCreditCurrency }}</div>
      <input-with-spinner
        formControlName="franchiseCreditInFranchiseCreditCurrency"
        [inputValidator]="['numericShorthand']"
        [required]="true"
        [useBasicTextBox]="true"
        (onBlur)="onCreditBlur('franchiseCreditInFranchiseCreditCurrency')"
      ></input-with-spinner>
      <div></div>
    </div>
  </form>
  @if (rfqTradeCaptureParams) {
    <ng-container *ngTemplateOutlet="rfqTradeCaptureParamsTmpl" />
  }
</div>

<ng-template #rfqTradeCaptureParamsTmpl>
  <form [formGroup]="rfqTradeCaptureParamsForm" [inert]="state() === 'BOOKED'">
    <div class="book-trade__rfq-trade-capture-params">
      @for (row of rfqTradeCaptureParams; track $index) {
        <div class="book-trade__rfq-trade-capture-params_item">
          {{ row.longName }}
        </div>
        <div
          class="book-trade__rfq-trade-capture-params_item-attribute-container book-trade__rfq-trade-capture-params_item-attribute-container--{{
            row.shortName
          }}"
        >
          @switch (row.type) {
            @case ('enum') {
              <select clrSelect [formControlName]="row.shortName">
                @for (option of row.values; track $index) {
                  <option>{{ option }}</option>
                }
              </select>
            }
            @case ('boolean') {
              <input
                [formControlName]="row.shortName"
                type="checkbox"
                clrCheckbox
                [checked]="row.default"
              />
            }
            @default {
              @switch (row.shortName) {
                @case ('tradeBookingPremiumCurrency') {
                  <select
                    clrSelect
                    [formControlName]="row.shortName"
                    (change)="
                      tradeBookingPremiumCurrencyChange(
                        $any($event.target).value
                      )
                    "
                  >
                    @for (premium of premiums; track $index) {
                      <option [value]="premium">{{ premium }}</option>
                    }
                  </select>
                }
                @case ('tradeBookingPremiumStyle') {
                  <select
                    clrSelect
                    [formControlName]="row.shortName"
                    (change)="premiumStyleChange($any($event.target).value)"
                  >
                    @for (
                      premiumStyle of tradeBookingPremiumStyles;
                      track $index
                    ) {
                      <option [value]="premiumStyle">
                        {{ premiumStyle }}
                      </option>
                    }
                  </select>
                }
                @case ('forcedCashSettlementCurrency') {
                  <select clrSelect [formControlName]="row.shortName">
                    @for (p of premiums; track $index) {
                      <option>{{ p }}</option>
                    }
                  </select>
                }
                @case ('confirmationType') {
                  @if (showConfirmationType) {
                    <select
                      clrSelect
                      [formControlName]="row.shortName"
                      [required]="true"
                    >
                      @for (p of row.enum; track $index) {
                        <option>{{ p }}</option>
                      }
                    </select>
                  }
                }
                @case ('forcedCashSettlementFixingSource') {
                  <select clrSelect [formControlName]="row.shortName">
                    @for (cp of fixingSourceCodes; track $index) {
                      <option [value]="cp">
                        {{ fixingSourceCodeToLongNameMap[cp] }}
                      </option>
                    }
                  </select>
                }
                @case ('volumeCredit') {
                  <div class="volume-credit">
                    <input
                      [formControlName]="row.shortName"
                      [inputValidator]="['numericShorthand']"
                      type="text"
                      clrInput
                    />
                    <span class="vol-credit-ccy">
                      {{
                        rfqTradeCaptureParamsForm.get('volumeCreditCurrency')
                          .value
                      }}
                    </span>
                  </div>
                }
              }
            }
          }
        </div>
      }
    </div>
  </form>
</ng-template>

<ng-template #enableGenericMultiHedgeEditingTmpl>
  <ng-container [formGroup]="acceptedQuoteForm">
    <ng-container formArrayName="hedgeBooking">
      <ng-container
        *ngFor="let bookedHedge of hedgeBooking.controls; let i = index"
      >
        <ng-container [formGroupName]="i">
          <div></div>
          <div>
            Hedge:
            @if (bookedHedge.value['executionType'] === 'Live') {
              {{ parentPricesComponent.parent | uppercase }}
              {{
                bookedHedge.value['hedgePosition'] === 'Buy' ? 'Sells' : 'Buys'
              }}
            } @else {
              Client {{ bookedHedge.value['hedgePosition'] + 's' }}
            }
          </div>
          <div>{{ currencyPair?.base }}</div>
          <div>
            <input-with-spinner
              formControlName="hedgeAmount"
              class="bookedHedgeAmount"
              [inputValidator]="['numericShorthand']"
              [tabIndex]="-1"
              (onBlur)="onHedgeBlur()"
              (change)="reprice()"
            ></input-with-spinner>
          </div>
          <div class="hedge-rate">
            <span>at</span>
            <input-with-spinner
              formControlName="hedgeRate"
              class="bookedHedgeRate"
              [inputValidator]="['positiveNumber']"
              [tabIndex]="-1"
              [type]="'number'"
              (onBlur)="onHedgeBlur()"
              (change)="reprice()"
            ></input-with-spinner>
          </div>
          <div class="hedge-delivery-date">
            {{ bookedHedge.value['hedgeDeliveryDate'] | date: 'dd MMM yyyy' }}
          </div>
          <div *ngIf="useRetrocessionFee"></div>
          <div></div>
          <ng-container *ngIf="premiumStyle !== 'Amount'">
            <div></div>
            <div></div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #enableHedgeEditingTmpl>
  <ng-container [formGroup]="acceptedQuoteForm">
    <div></div>
    <div>
      Hedge:
      {{ nonDxExists ? (parentPricesComponent.parent | uppercase) : 'Client' }}

      {{
        nonDxExists
          ? invertDirection(acceptedQuoteForm.value.bookedHedgePosition)
          : acceptedQuoteForm.value.bookedHedgePosition
      }}s
    </div>
    <div>{{ currencyPair?.base }}</div>
    <div>
      <input-with-spinner
        formControlName="bookedHedgeAmount"
        class="bookedHedgeAmount"
        [inputValidator]="['numericShorthand']"
        [tabIndex]="-1"
        (onBlur)="onHedgeBlur()"
      ></input-with-spinner>
    </div>
    <div class="hedge-rate">
      <span>at</span>
      <input-with-spinner
        formControlName="bookedHedgeRate"
        class="bookedHedgeRate"
        [inputValidator]="['positiveNumber']"
        [tabIndex]="-1"
        [type]="'number'"
        (onBlur)="onHedgeBlur()"
      ></input-with-spinner>
    </div>
    <div></div>
    <div *ngIf="useRetrocessionFee"></div>
    <div></div>
    <ng-container *ngIf="premiumStyle !== 'Amount'">
      <div></div>
      <div></div>
    </ng-container>
  </ng-container>
</ng-template>
